export default function arrayCopy(array: any[]) {
    return JSON.parse(JSON.stringify(array));
}
